export default __webpack_public_path__ + "static/media/existingAgendaIcon.24ff03f1.svg";